var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgNeo(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 18,
    viewBox: "0 0 18 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_722_32806)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M9 18C13.9706 18 18 13.9706 18 9C18 4.02944 13.9706 0 9 0C4.02944 0 0 4.02944 0 9C0 13.9706 4.02944 18 9 18Z",
    fill: "#58BF00"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M14.0625 12.7013L10.1306 10.8686V6.80738L14.0625 5.41294V12.7013ZM8.33794 14.625L4.5 12.8368V5.60138L8.33794 7.39012V14.625ZM13.9686 5.15081L13.905 5.17331L10.1306 6.51262L10.0361 6.54637L8.43694 7.11337L4.65131 5.34938L10.0361 3.43912L10.0834 3.42225L10.1829 3.38681L10.2178 3.375L14.0034 5.139L13.9686 5.15081Z",
    fill: "white"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_722_32806"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 18,
    height: 18,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgNeo);
export default __webpack_public_path__ + "static/media/neo.32c533e9927118ab4044cf2ef08140b9.svg";
export { ForwardRef as ReactComponent };